import { CopilotWorkflow } from "../../store/copilot/CopilotStore";
import { axiosInstance } from "../../utils/axios";
import env from "../../utils/env";
import { CopilotContext, Message, RateType, Thread } from "./types";

const COPILOT_API_URL = "/api/copilot";
const COPILOT_BASE_URL = `${env.PLATFORM_URL_BASE}${COPILOT_API_URL}`;

const apiInst = axiosInstance;

// Store active AbortControllers for /messages requests
const activeMessageControllers = new Set<AbortController>();

export const abortAllMessages = () => {
  activeMessageControllers.forEach((controller) => {
    controller.abort();
  });
  activeMessageControllers.clear();
};

export const createThread = async (
  userName: string,
  workflow: CopilotWorkflow,
  context: CopilotContext
) => {
  const res = await apiInst.post<Thread>(
    `${COPILOT_API_URL}/threads`,
    {
      workflow,
      ...(context
        ? {
            context,
          }
        : {}),
    },
    {
      headers: {
        "x-user-name": userName,
        "x-agentic": true,
      },
    }
  );

  return res.data;
};

export const sendMessage = (
  threadId: string,
  content: string,
  context: CopilotContext,
  onAnswers?: (answers: Message[]) => void,
  onFinish?: () => void
) => {
  const payload = { message: content, context, stream: true };
  const controller = new AbortController();
  activeMessageControllers.add(controller);

  fetch(`${COPILOT_BASE_URL}/threads/${threadId}/messages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream",
      Authorization: `Bearer ${localStorage.access_token}`,
      "x-agentic": "true",
    },
    body: JSON.stringify(payload),
    signal: controller.signal,
  })
    .then((response) => {
      const reader = response.body!.getReader();
      const decoder = new TextDecoder("utf-8");

      const read = () => {
        reader
          .read()
          .then(({ done, value }) => {
            if (done) {
              activeMessageControllers.delete(controller);
              if (onFinish) onFinish();
              return;
            }

            const answers: Message[] = decoder
              .decode(value, { stream: true })
              .replace(/data: /g, "")
              .split(/\r?\n/)
              .filter(Boolean)
              .map((line) => {
                try {
                  return JSON.parse(line);
                } catch {
                  return null;
                }
              })
              .filter(Boolean);

            if (onAnswers) onAnswers(answers);

            // Repeat
            read();
          })
          .catch(() => {
            activeMessageControllers.delete(controller);
            if (onFinish) onFinish();
            return;
          });
      };

      read();
    })
    .catch(() => {
      activeMessageControllers.delete(controller);
      if (onFinish) onFinish();
      return;
    });

  // console.log(threadId);
  // const res = await fetch(`${COPILOT_API_URL}/threads/${threadId}/messages`, {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "text/event-stream",
  //     Authorization: `Bearer ${localStorage.access_token}`,
  //     "x-agentic": "true",
  //     stream: "true",
  //   },
  //   body: JSON.stringify({
  //     message: content,
  //     context,
  //   }),
  // });

  // // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  // const reader = res.body!.getReader();
  // const decoder = new TextDecoder();

  // while (true) {
  //   const { value, done } = await reader.read();
  //   if (done) break;
  //   const chunk = decoder.decode(value, { stream: true });
  //   console.log(chunk);
  // }

  // const res = await apiInst.post<{ message: Message | Message[] }>(
  //   `${COPILOT_API_URL}/threads/${threadId}/messages`,
  //   {
  //     stream: true,
  //     message: content,
  //     context,
  //   },
  //   {
  //     headers: {
  //       "x-agentic": true,
  //     },
  //   }
  // );

  // console.log(res);

  // TBD: When the API starts to return an array, remove the following manipulation
  // return Array.isArray(res.data.message)
  //   ? res.data.message
  // : [res.data.message];

  return [];
};

export const rateMessage = async (
  threadId: string,
  messageId: string,
  rateType: RateType,
  rateValue: number | null
) => {
  await apiInst.post<{ message: Message | Message[] }>(
    `${COPILOT_API_URL}/threads/${threadId}/messages/${messageId}/rate`,
    {
      rate_type: rateType,
      rate_value: rateValue,
    },
    {
      headers: {
        "x-agentic": true,
      },
    }
  );

  return;
};

export const retryMessage = async (threadId: string, messageId: string) => {
  const res = await apiInst.post<{ message: Message[] }>(
    `${COPILOT_API_URL}/threads/${threadId}/messages/${messageId}/retry`,
    {
      headers: {
        "x-agentic": true,
      },
    }
  );

  return res.data.message;
};
